import { clearPortalSentryUser } from '@admin-panel/observability';
import { LOCAL_GATEWAY_AUTH_BYPASS_ENABLED } from '@admin-panel/config/env';

type HttpErrorLike = {
  response?: {
    status?: unknown;
  };
  status?: unknown;
  statusCode?: unknown;
};

let hasHandledUnauthorizedSession = false;

const toStatusCode = (value: unknown): number | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string') {
    const parsedValue = Number(value);
    if (Number.isFinite(parsedValue)) {
      return parsedValue;
    }
  }

  return undefined;
};

export const getHttpStatusCode = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null) {
    return undefined;
  }

  const maybeError = error as HttpErrorLike;

  return (
    toStatusCode(maybeError.response?.status) ??
    toStatusCode(maybeError.statusCode) ??
    toStatusCode(maybeError.status)
  );
};

export const isUnauthorizedHttpError = (error: unknown) => getHttpStatusCode(error) === 401;

export const resetUnauthorizedSessionHandling = () => {
  hasHandledUnauthorizedSession = false;
};

export const clearClientStorage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  clearPortalSentryUser();
  localStorage.clear();
  sessionStorage.clear();
};

export const redirectToLogin = () => {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
};

export const handleUnauthorizedSessionExpiry = () => {
  if (LOCAL_GATEWAY_AUTH_BYPASS_ENABLED) {
    return;
  }

  if (hasHandledUnauthorizedSession) {
    return;
  }

  hasHandledUnauthorizedSession = true;
  clearClientStorage();
  redirectToLogin();
};
